
<div class="mt-3">
<h1 *ngIf="showMyPoints" class="text-center">My current points: {{ points }}</h1>
    <table mat-table [dataSource]="data" matSort matSortActive="cost" matSortDirection="desc"
        class="mat-elevation-z8">

        <ng-container matColumnDef="imgURL">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Image </th>
            <td mat-cell *matCellDef="let element" class="img-container"><img [src]="element.imgURL" alt="" class="img-thumbnail" onerror="this.src='assets/img/prize.jpg'"></td>
        </ng-container>

        <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Prize </th>
            <td mat-cell *matCellDef="let element"> {{element.name}} </td>
        </ng-container>

        <ng-container matColumnDef="cost">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Cost </th>
            <td mat-cell *matCellDef="let element"> {{element.cost}} </td>
        </ng-container>

        <ng-container matColumnDef="description">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Description </th>
            <td mat-cell *matCellDef="let element"> {{element.description}} </td>
        </ng-container>

        <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Action </th>
            <td mat-cell *matCellDef="let element"> <button mat-button color='accent' (click)="updatePrizes(element)" disabled = "{{element.redeemable}}">{{ actionType }}</button> </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns" ></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
    <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
</div>